import React, { useState, useEffect } from "react";
import * as Sentry from '@sentry/browser';
import Api from "../../Api";
import classes from "./styles.module.css";

/**
 * AntiFraudConfigTab — настройка антифрод каскада для мерчанта.
 *
 * Props:
 *   token (string)
 *   terminal (object) — { id, projectUuid, ... }
 */
function AntiFraudConfigTab(props) {
    var token = props.token;
    var terminal = props.terminal;

    var _frodEnabled = useState(false);
    var frodEnabled = _frodEnabled[0];
    var setFrodEnabled = _frodEnabled[1];

    var _antifraud = useState({
        payment: { database: false, client: false, scanfraud: false },
        payout: { database: false, client: false, scanfraud: false },
    });
    var antifraud = _antifraud[0];
    var setAntifraud = _antifraud[1];

    var _saving = useState(false);
    var saving = _saving[0];
    var setSaving = _saving[1];

    var _loading = useState(true);
    var loading = _loading[0];
    var setLoading = _loading[1];

    var _status = useState(null);
    var status = _status[0];
    var setStatus = _status[1];

    // Загрузить текущие настройки из /merchant/{uuid}/full
    useEffect(function () {
        if (!terminal || !terminal.id || !terminal.projectUuid) return;
        setLoading(true);
        setStatus(null);

        var api = new Api({ token: token });
        api.getFullMerchant(terminal.projectUuid).then(function (data) {
            var settings = (data && data.settings) || [];
            // Берём первый MS привязанный к этому терминалу
            var ms = null;
            for (var i = 0; i < settings.length; i++) {
                if (settings[i].terminalId === terminal.id) {
                    ms = settings[i];
                    break;
                }
            }

            if (ms) {
                setFrodEnabled(!!ms.frod);
                var af = ms.antifraud || {};
                setAntifraud({
                    payment: {
                        database: !!(af.payment && af.payment.database),
                        client: !!(af.payment && af.payment.client),
                        scanfraud: !!(af.payment && af.payment.scanfraud),
                    },
                    payout: {
                        database: !!(af.payout && af.payout.database),
                        client: !!(af.payout && af.payout.client),
                        scanfraud: !!(af.payout && af.payout.scanfraud),
                    },
                });
            }
            setLoading(false);
        }).catch(function (err) {
            Sentry.captureException(err);
            setLoading(false);
            setStatus({ type: "error", text: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438" });
        });
    }, [terminal && terminal.id, terminal && terminal.projectUuid, token]);

    function onToggle(group, key) {
        setAntifraud(function (prev) {
            var next = {
                payment: Object.assign({}, prev.payment),
                payout: Object.assign({}, prev.payout),
            };
            next[group][key] = !next[group][key];
            return next;
        });
    }

    function onSave() {
        if (!terminal.projectUuid) return;
        setSaving(true);
        setStatus(null);

        var api = new Api({ token: token });
        api.setFrodData(terminal.projectUuid, {
            frod: frodEnabled,
            antifraud: antifraud,
        }).then(function () {
            setSaving(false);
            setStatus({ type: "success", text: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B" });
        }).catch(function (err) {
            Sentry.captureException(err);
            setSaving(false);
            var msg = (err && err.response && err.response.data && err.response.data.message) || "\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F";
            setStatus({ type: "error", text: msg });
        });
    }

    function renderToggle(group, key, label, desc, paid) {
        return React.createElement("div", { className: classes.Toggle, key: group + "_" + key },
            React.createElement("input", {
                type: "checkbox",
                checked: antifraud[group][key],
                onChange: function () { onToggle(group, key); },
            }),
            React.createElement("div", { className: classes.ToggleInfo },
                React.createElement("div", { className: classes.ToggleLabel }, label),
                React.createElement("div", { className: classes.ToggleDesc }, desc)
            ),
            React.createElement("span", {
                className: paid ? classes.PaidBadge : classes.FreeBadge,
            }, paid ? "\u041F\u043B\u0430\u0442\u043D\u043E" : "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E")
        );
    }

    function renderGroup(title, group) {
        return React.createElement("div", { className: classes.Group + (!frodEnabled ? " " + classes.Disabled : "") },
            React.createElement("div", { className: classes.GroupTitle }, title),
            renderToggle(group, "database", "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0431\u0430\u0437\u0430 (\u0422\u041A\u0411, FinStar)", "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u043E \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u0431\u0430\u0437\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u0432", false),
            renderToggle(group, "client", "NX \u0441\u0445\u0435\u043C\u0430", "\u0411\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E\u0441\u043B\u0435 \u043D\u0435\u0443\u0434\u0430\u0447\u043D\u044B\u0445 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 (NX blocks)", false),
            renderToggle(group, "scanfraud", "ScanFraud API", "\u0412\u043D\u0435\u0448\u043D\u0438\u0439 \u0441\u0435\u0440\u0432\u0438\u0441 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438 \u043C\u043E\u0448\u0435\u043D\u043D\u0438\u0447\u0435\u0441\u0442\u0432\u0430", true)
        );
    }

    if (loading) {
        return React.createElement("div", { className: classes.Container }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
    }

    return React.createElement("div", { className: classes.Container },
        React.createElement("div", { className: classes.Title }, "\u0410\u043D\u0442\u0438\u0444\u0440\u043E\u0434 \u043A\u0430\u0441\u043A\u0430\u0434"),

        React.createElement("div", { className: classes.MasterToggle },
            React.createElement("input", {
                type: "checkbox",
                checked: frodEnabled,
                onChange: function () { setFrodEnabled(!frodEnabled); },
                id: "frod-master-toggle",
            }),
            React.createElement("label", { htmlFor: "frod-master-toggle" }, "\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434")
        ),

        renderGroup("\u041E\u043F\u043B\u0430\u0442\u0430 (Payment)", "payment"),
        renderGroup("\u0412\u044B\u043F\u043B\u0430\u0442\u044B (Payout)", "payout"),
        // Выплаты по API проверяются и по блоку антифрода терминала, которого
        // на этой вкладке нет: без подсказки оператор видит неполную картину.
        React.createElement("div", { className: classes.ToggleDesc }, "\u0414\u043B\u044F \u0432\u044B\u043F\u043B\u0430\u0442 \u043F\u043E API \u043A \u044D\u0442\u0438\u043C \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u043C \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0440\u0443\u0447\u043D\u044B\u0435 \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438 \u0438 ScanFraud, \u0432\u043A\u043B\u044E\u0447\u0451\u043D\u043D\u044B\u0435 \u043D\u0430 \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0435 (\u0431\u043B\u043E\u043A \u0430\u043D\u0442\u0438\u0444\u0440\u043E\u0434\u0430 CRM-\u0437\u0430\u044F\u0432\u043E\u043A)."),

        React.createElement("button", {
            className: classes.SaveBtn,
            onClick: onSave,
            disabled: saving,
        }, saving ? "\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435..." : "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C"),

        status && React.createElement("div", {
            className: classes.StatusMsg + " " + (status.type === "success" ? classes.StatusSuccess : classes.StatusError),
        }, status.text)
    );
}

export default AntiFraudConfigTab;



// WEBPACK FOOTER //
// ./src/Components/AntiFraudConfigTab/index.js